<template>
		<div class="home-page">
      <div class="bgfff">
        <Header></Header>
        <div class="nav ac">
          <div class="back" @click="back" >
            <img width="40" src="../../static/images/back2.png" />
          </div>
          {{$t('Profile')}}
        </div>
      </div>
      <div class="info">

        <div class="at-img ac por">
<!--          <input class="upload-image" type="file" @change="handleFileUpload" accept="image/*">-->
          <img class="account-img" :src="avatar" />
        </div>
        <div class="account-content">
          <div class="ac">
            <div v-if="isEdit" class="flex" style="margin:20px 0;">
              <input class="fen" style="margin:0px 10px 0 0;width:70%;font-size: 28px;" v-model="nickname" />
              <button class="button" style="width: 30%;padding: 14px 20px;" @click="editSub">{{$t('Submit')}}</button>
            </div>
            <div v-else>
              <span class="name-span app-en">{{info.nickname}}</span>
              <span class=" crff1d4f fs33" @click="editName">
                <img width="30" class="edit" src="static/images/edit.png" />
              </span>
            </div>
          </div>
          <div class="account-center">
            <div>{{$t('current_level')}}:<span class="red"> {{info.level_name}}</span></div>
            <div style="margin-top: 15px">{{$t('Current Challenge Level')}}:<span class="red"> {{info.task_level}}</span></div>
            <div style="margin-top: 15px">{{$t('sub_type')}}:<span class="red"> {{info.subappid_name}}</span></div>
          </div>

          <div class="change-list2 mt50 crfff ac por">
            <div class="fs27 pt20">{{$t('Re_admission')}}</div>
            <div class="change-list ac">
              <button class="button" @click="reRating">{{$t('Re_testing')}}</button>
            </div>
          </div>
          <div class="change-list2 mt50 crfff ac por">
            <div class="fs27 pt20">{{$t('language')}}</div>
              <div class="change-list ac">
                <div class="one" @click="getLang(2,'bur')" :class="{'active':isShowLang=='bur'}">
                    <img class="dui" :src="isShowLang=='bur'?'../../static/images/selected.png':'../../static/images/select.png'">
                  <span>{{$t('Myanmar')}}</span>
                </div>
                <div class="one" @click="getLang(2,'en')" :class="{'active':isShowLang=='en'}">
                  <img class="dui" :src="isShowLang=='en'?'../../static/images/selected.png':'../../static/images/select.png'">
                  <span>{{$t('English')}}</span>
                </div>
              </div>
          </div>

          <div class="change-list2 mt50 crfff ac por">
            <div class="fs27 pt20">{{$t('Background_Music')}}</div>
            <div class="change-list ac">
              <div class="kai" @click="getShow(1)" v-if="isShow"><img src="../../static/images/kai.png"></div>
              <div class="kai kai2" @click="getShow(2)" v-else><img src="../../static/images/kai2.png"></div>
            </div>
          </div>
          <div class="ac mt50">
            <button class="button guidance" @click="guidance">
              <span class="icon">i</span>
              <span>{{$t('guidance')}}</span>
            </button>
          </div>
          <div class="ac mt50">
             <button class="button unSubscribe" @click="unSubscribe">{{$t('Unsucscribe')}}</button>
           </div>
          </div>
        </div>
			</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'

export default {
    components:{
		Header,
    Dialog
    },
    data() {
        return {
          disAbled:'',
          isEdit:false,
          info:'',
          nickname:'',
          base64Image:'',
          lang:'',
          isShowLang:'bur',
          isShow:this.$parent.isBgmPlaying || false,
          avatar: "../../static/images/account.png",
        }
    },
    mounted() {
		let that = this;
    },
	created(){

      if(localStorage.getItem('lang')){
        this.isShowLang = localStorage.getItem('lang')
      }
		this.getHome();
    this.isShow = JSON.parse(localStorage.getItem('BackgroundMusic'))
	},
    methods: {
      reRating() {
        this.$router.push({path:'/leveltest'});
      },
      guidance() {
        this.$router.push({path:'/guidance'});
      },
      getLang(type,lang){
        if(type==2){
          this.isShowLang = lang
          this.lang = lang
          localStorage.setItem('lang',this.lang)
          location.reload()
        }else{
        }
      },
      handleFileUpload(event) {
        let that = this;
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            console.log(e);
            this.base64Image = e.target.result;

            // 从Base64字符串中提取图片类型
            const matches = this.base64Image.match(/^data:image\/([A-Za-z-+/]+);base64,/);
            const type = matches ? matches[1] : '';

            that.uploadImage(type);
          };
          reader.readAsDataURL(file);
        }
      },

      async uploadImage(imageType) {
        let that = this
        if (!this.base64Image) {
          that.$utils.alertText('pls select picture',80);
          return;
        }
        try {
          let data = {
            image: {
              "content": this.base64Image,
              "type": imageType || "" // 使用提取的类型，如果没有则留空
            }
          }
          that.$parent.loadModal(true);
          that.$api.post('/api/user/upload_avatar', data, r => {
            that.$parent.returnCode(r, function() {
              that.$utils.alertText(r.msg,80);
              that.getHome()
              that.$parent.loadModal(false);
            });
          })
        } catch (error) {
          that.$utils.alertText(r.msg,80);
        }
      },
		back(){
			this.$router.go(-1);
		},
    editName(){
      this.isEdit = true
      this.nickname = this.info.nickname
    },
    editSub(){
      let that =this;
      let data = {
        nickname:that.nickname
      }
      that.$api.post('/api/user/profile',data,r =>{
      	that.$parent.returnCode(r,function(){
      		//that.info = r.data
          that.isEdit = false
          that.getHome()
      		that.$parent.loadModal(false);
        });

      })
    },
		getHome(){
			let that =this;
			that.$api.post('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
					that.info = r.data
          localStorage.setItem('avatar',r.data.avatar)
					that.$parent.loadModal(false);
        });

			})
		},

    unSubscribe(){
    	let that =this;
    	that.$parent.loadModal(true);
    	that.$api.post('api/user/unsubscribe',null,r =>{
    		that.$parent.returnCode(r,function(){
    	    that.$parent.loadModal(false);
          that.$utils.alertText(r.msg,80);
          if (r.code == 1 ){
            localStorage.removeItem('token')
            localStorage.removeItem('mobile')
            that.$router.push({path:'/login'});
          }

    	  });
    	})
    },
      getShow(type){
        if (type === 1) {
          this.isShow = false;
          this.$parent.stopBackgroundMusic(); // 使用 $parent 访问
        } else {
          this.isShow = true;
          this.$parent.startBackgroundMusic(); // 使用 $parent 访问
        }
      },
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/myAccount.vue